import React from 'react';
import { components } from '@seaoil/component-lib';
import { LayoutWithNav } from '../components/Layout';

const { Auth } = components;

function LoginPage() {
  const signIn = () => Auth.signin();
  const signOut = () => Auth.signout();

  return (
    <LayoutWithNav>
      <div>
        <Auth.PublicComponent>
          <p>Please login...</p>
          <button type="button" onClick={signIn}>Sign In</button>
        </Auth.PublicComponent>

        <Auth.PrivateComponent>
          <p>In case you want to logout...</p>
          <button type="button" onClick={signOut}>Sign Out</button>
        </Auth.PrivateComponent>
      </div>
    </LayoutWithNav>
  );
}

export default LoginPage;
